import { authApiService } from '@/api/authApiService';
import { ApiResponseType } from '@/types/sharedTypes';
import { VendorVaultCatalogType } from '@/types/vendorVaultTypes';

export const getVendorVaultCatalogApi = (): Promise<ApiResponseType<VendorVaultCatalogType>> =>
  authApiService.GET('/vendor-vault/catalog/');
